(() => {
  const init = (root) => {
    if (!root || !root.matches('[data-tan-wedding-moment]') || root.dataset.weddingJourneyReady) return;
    root.dataset.weddingJourneyReady = 'true';

    const preview = root.querySelector('[data-wedding-wall-preview]');
    const choices = Array.from(root.querySelectorAll('[data-wedding-zone-choice]'));
    const ambient = root.querySelector('[data-wedding-ambient]');
    const ambientValue = root.querySelector('[data-wedding-ambient-value]');
    const resultHeading = root.querySelector('[data-wedding-zone-heading]');
    const resultCopy = root.querySelector('[data-wedding-zone-copy]');
    const resultList = root.querySelector('[data-wedding-zone-list]');
    const frameLabel = root.querySelector('[data-wedding-frame-label]');

    const updateChoice = (choice) => {
      if (!choice || !preview) return;
      choices.forEach((item) => {
        const active = item === choice;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-pressed', String(active));
      });

      preview.dataset.mode = choice.dataset.modeKey || 'welcome';
      if (resultHeading) resultHeading.textContent = choice.dataset.zoneTitle || '';
      if (resultCopy) resultCopy.textContent = choice.dataset.zoneNote || '';

      const payload = root.querySelector(`[data-wedding-zone-payload="${CSS.escape(choice.dataset.zoneId || '')}"]`);
      const content = payload?.content.querySelector('[data-wedding-zone-checklist]');
      if (resultList && content) resultList.innerHTML = content.innerHTML;
      if (frameLabel) frameLabel.textContent = choice.dataset.frameLabel || '';

      ['viewer', 'constraint', 'evidence'].forEach((metric) => {
        const label = root.querySelector(`[data-wedding-metric-label="${metric}"]`);
        const value = root.querySelector(`[data-wedding-metric-value="${metric}"]`);
        if (label) label.textContent = choice.dataset[`${metric}Label`] || '';
        if (value) value.textContent = choice.dataset[`${metric}Value`] || '';
      });
    };

    const updateAmbient = () => {
      if (!ambient || !preview) return;
      const strength = Number(ambient.value) / 100;
      preview.style.setProperty('--wedding-daylight', String(0.08 + strength * 0.52));
      preview.style.setProperty('--wedding-glow', String(0.72 + (1 - strength) * 0.28));
      preview.style.setProperty('--wedding-room-light', String(0.18 + strength * 0.62));
      if (ambientValue) ambientValue.textContent = `${ambient.value}%`;
    };

    choices.forEach((choice) => choice.addEventListener('click', () => updateChoice(choice)));
    ambient?.addEventListener('input', updateAmbient);
    updateAmbient();
  };

  const initAll = (scope = document) => {
    if (scope.matches?.('[data-tan-wedding-moment]')) init(scope);
    scope.querySelectorAll?.('[data-tan-wedding-moment]').forEach(init);
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => initAll());
  else initAll();
  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();
